module.exports = __webpack_public_path__ + "img/shar_yes.1b1ad191.png";